export default __webpack_public_path__ + "static/media/canvas-orange.771592b2.webp";